import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-resumen',
  templateUrl: './resumen.component.html',
  styleUrls: ['./resumen.component.css']
})
export class ResumenComponent implements OnInit {
  resumenForm: FormGroup;
  totalActivos = 0;
  totalPasivos = 0;
  estadoSituacionGuid : any;
  persona: any;
  formFirmado = false;
  constructor(private dataService: DataService, private personaService: PersonaService, private router: Router, private stepperService: StepperService) { 
    this.resumenForm = new FormGroup({
      firmaEstado: new FormControl(false, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.personaService.persona$.subscribe({
      next: (persona) => {
        if (persona) {
          this.persona = persona;
          this.estadoSituacionGuid = persona.estadoSituacion.guid;
          console.log("persona", persona);
          console.log("estadoSituacionGuid", this.estadoSituacionGuid);
          console.log("estadoSituacion", persona.estadoSituacion);
          console.log("estadoSituacionActivos", persona.estadoSituacion.personaActivos);
          console.log("estadoSituacionPasivos", persona.estadoSituacion.personaPasivos);
          
          // Asegúrate de que los valores sean números antes de sumarlos
          this.totalPasivos = persona.estadoSituacion.personaPasivos?.reduce((sum: number, pasivo: any) => sum + Number(pasivo.monto), 0) || 0;
          this.totalActivos = persona.estadoSituacion.personaActivos?.reduce((sum: number, activo: any) => sum + Number(activo.valorComercial), 0) || 0;
          
          console.log("totalPasivos", this.totalPasivos);
          console.log("totalActivos", this.totalActivos);
          
          if (persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
            this.resumenForm.get('firmaEstado')?.patchValue(true);
            this.formFirmado = true;
            this.resumenForm.disable();
          }
        }
      },
      error: (err) => console.log(err)
    });
  }

  onSubmit() {
    if(this.resumenForm.get('firmaEstado')?.value) {
      var url = `estado-situacion/${this.personaService.getPersonaGuid()}/firma`;
      this.dataService.postData(null, url).subscribe({
        next: (v) => {
            this,this.router.navigate(["home"]);
        },
        error: (e) => console.log(e),
        complete: () => {
          this.personaService.setPersona();
        },
      });
    }else{
      Swal.fire({
        title: 'Ooop!!',
        text: 'Por favor, antes de firmar debes aceptar los terminos y condiciones.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  }

  volver(){
    this.stepperService.prevStep();
  }

  toHome(){
    this.router.navigate(["home"]);
  }
}
